const resources = {
    bopisTitle: 'Paiement de la commande « Achetez en ligne, ramassez en magasin »',
    sadTitle: 'Paiement de l’expédition et de la livraison',
    confirmSelection: 'Veuillez confirmer votre sélection',
    paypalAddressUnverified:
        'L’adresse d’expédition de PayPal n’a pas pu être vérifiée. Veuillez mettre à jour votre adresse d’expédition avant de continuer.'
};

export default function getResource(label) {
    return resources[label];
}
